/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Health_Nav_AriaInputs */

const en_service_health_nav_aria = /** @type {(inputs: Service_Health_Nav_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to Health Navigation Platform`)
};

const fr_service_health_nav_aria = /** @type {(inputs: Service_Health_Nav_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien vers la plateforme de navigation en santé`)
};

/**
* | output |
* | --- |
* | "Link to Health Navigation Platform" |
*
* @param {Service_Health_Nav_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_health_nav_aria = /** @type {((inputs?: Service_Health_Nav_AriaInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Health_Nav_AriaInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_health_nav_aria(inputs)
	return fr_service_health_nav_aria(inputs)
});